var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDoubleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V9.61598L9.50172 8.04253C9.19384 7.76543 8.71962 7.79039 8.44253 8.09828C8.16543 8.40616 8.19039 8.88038 8.49828 9.15747L11.4983 11.8575C11.7835 12.1142 12.2165 12.1142 12.5017 11.8575L15.5017 9.15747C15.8096 8.88037 15.8346 8.40616 15.5575 8.09828C15.2804 7.79039 14.8062 7.76543 14.4983 8.04253L12.75 9.61598V5ZM12.75 13.4C12.75 12.9858 12.4142 12.65 12 12.65C11.5858 12.65 11.25 12.9858 11.25 13.4V17.316L9.50172 15.7425C9.19384 15.4654 8.71962 15.4904 8.44253 15.7983C8.16544 16.1062 8.19039 16.5804 8.49828 16.8575L11.4983 19.5575C11.7835 19.8142 12.2165 19.8142 12.5017 19.5575L15.5017 16.8575C15.8096 16.5804 15.8346 16.1062 15.5575 15.7983C15.2804 15.4904 14.8062 15.4654 14.4983 15.7425L12.75 17.316V13.4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDoubleDown);
export default __webpack_public_path__ + "static/media/arrow-double-down.16e784c24ef79969846a38af2254b3dc.svg";
export { ForwardRef as ReactComponent };